// src/clients/cart/services/transfer-helpers.ts
// Helpers puros para detectar/unificar transfers sin depender del tipo completo del carrito.

export function esTransferGenerico(p: {
  descripcion?: string;
  observacion?: string;
  cod_drog?: string;
  tipo_solicitante?: string;
  es_transfer?: boolean;
  transfer?: any;
  [k: string]: any;
}): boolean {
  const d = (p.descripcion || "").toLowerCase();
  const o = (p.observacion || "").toLowerCase();
  const c = (p.cod_drog || "").toLowerCase();
  return (
    d.includes("transfer") ||
    o.includes("transfer") ||
    c.includes("transfer") ||
    c.includes("trf") ||
    p.tipo_solicitante === "T" ||
    p.es_transfer === true ||
    p.transfer === "S" ||
    p.transfer === true
  );
}

export function extraerLaboratorioGenerico(p: {
  laboratorio?: string;
  observacion?: string;
}): string {
  if (p.laboratorio) return p.laboratorio;
  const m = (p.observacion || "").match(/Transfer Lab:\s*([^-]+)/i);
  return m ? m[1].trim() : "SIN_LAB";
}

/**
 * Unifica líneas de transfer por (cod_drog + laboratorio),
 * sumando cantidades y totales, y recalculando unitario.
 */
export function unificarProductosTransfer<T extends {
  cod_drog?: string;
  descripcion?: string;
  observacion?: string;
  tipo_solicitante?: string;
  es_transfer?: boolean;
  transfer?: any;
  cantidad: number;
  precio_total: number;
  precio_unitario: number;
}>(productos: T[]): T[] {
  const map = new Map<string, T>();
  for (const prod of productos) {
    if (esTransferGenerico(prod)) {
      const clave = `${prod.cod_drog}_${extraerLaboratorioGenerico(prod)}`;
      if (map.has(clave)) {
        const ex = map.get(clave)!;
        const cantidadTotal = (ex.cantidad || 0) + (prod.cantidad || 0);
        const precioTotal = (ex.precio_total || 0) + (prod.precio_total || 0);
        map.set(clave, {
          ...ex,
          cantidad: cantidadTotal,
          precio_total: precioTotal,
          precio_unitario:
            cantidadTotal > 0 ? precioTotal / cantidadTotal : ex.precio_unitario,
          observacion: `${ex.observacion || ""} | Unificado: +${prod.cantidad}`.trim(),
        });
      } else {
        map.set(clave, { ...prod });
      }
    } else {
      map.set(`${prod.cod_drog}_${Math.random()}`, { ...prod });
    }
  }
  return Array.from(map.values());
}
